import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _deleteAllRequest = {};
var _deleteAllResponse = {};
var _deleteVoteRequest = {};
var _deleteVoteResponse = { vote: '_vote' };
var _downvoteRequest = {};
var _downvoteResponse = { vote: '_vote' };
var _queryVoteRequest = {};
var _queryVoteResponse = { votes: '_vote' };
var _upvoteRequest = {};
var _upvoteResponse = { vote: '_vote' };
var _vote = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixCritiqueReviewsV1VotesVotesUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/_api/reviews-votes',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/reviews-votes/v1',
                destPath: '/v1',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/_api/reviews-votes/v1',
                destPath: '/v1',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/reviews-votes/v1',
                destPath: '/v1',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/reviews-votes/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Upvote review */
export function upvote(payload) {
    var _a = serializer(_upvoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upvoteResponse, { _vote: _vote }).fromJSON;
    function __upvote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.vote',
            method: 'POST',
            methodFqn: 'wix.critique.reviews.v1.votes.Votes.Upvote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCritiqueReviewsV1VotesVotesUrl({
                protoPath: '/v1/votes/upvote',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upvote.fromReq = fromReq;
    __upvote.__isAmbassador = true;
    return __upvote;
}
export function downvote(payload) {
    var _a = serializer(_downvoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_downvoteResponse, { _vote: _vote }).fromJSON;
    function __downvote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.vote',
            method: 'POST',
            methodFqn: 'wix.critique.reviews.v1.votes.Votes.Downvote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCritiqueReviewsV1VotesVotesUrl({
                protoPath: '/v1/votes/downvote',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __downvote.fromReq = fromReq;
    __downvote.__isAmbassador = true;
    return __downvote;
}
/** Delete a Vote */
export function deleteVote(payload) {
    var _a = serializer(_deleteVoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteVoteResponse, { _vote: _vote }).fromJSON;
    function __deleteVote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.vote',
            method: 'DELETE',
            methodFqn: 'wix.critique.reviews.v1.votes.Votes.DeleteVote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCritiqueReviewsV1VotesVotesUrl({
                protoPath: '/v1/votes/{voteId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteVote.fromReq = fromReq;
    __deleteVote.__isAmbassador = true;
    return __deleteVote;
}
export function deleteAll(payload) {
    var _a = serializer(_deleteAllRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteAllResponse, {}).fromJSON;
    function __deleteAll(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.vote',
            method: 'DELETE',
            methodFqn: 'wix.critique.reviews.v1.votes.Votes.DeleteAll',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCritiqueReviewsV1VotesVotesUrl({
                protoPath: '/v1/votes/all',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAll.fromReq = fromReq;
    __deleteAll.__isAmbassador = true;
    return __deleteAll;
}
/** Query Votes using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryVote(payload) {
    var _a = serializer(_queryVoteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryVoteResponse, { _vote: _vote }).fromJSON;
    function __queryVote(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.reviews.v1.vote',
            method: 'POST',
            methodFqn: 'wix.critique.reviews.v1.votes.Votes.QueryVote',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixCritiqueReviewsV1VotesVotesUrl({
                protoPath: '/v1/votes/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryVote.fromReq = fromReq;
    __queryVote.__isAmbassador = true;
    return __queryVote;
}
//# sourceMappingURL=http.impl.js.map